import * as actionTypes from "../constants/actionTypes";
import axios from "axios";
import api from "../shared/api";

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START
  };
};

export const authSuccess = (token, path) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    token: token,
    path: path
  };
};

export const authFail = error => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error
  };
};
export const logout = () => {
  localStorage.removeItem("live555Token");
  localStorage.removeItem("expirationDate");
  return {
    type: actionTypes.AUTH_LOGOUT
  };
};

export const checkAuthTimeout = expirationTime => {
  return dispatch => {
    setTimeout(() => {
      dispatch(logout());
    }, expirationTime * 1000);
  };
};


export const auth = (username, password) => {
  return async dispatch => {
    //authenticate the user
    dispatch(authStart());
    let url = `${api}/auth/user/login`;
    const options = {
      url: url,
      method: 'POST',
      headers: {},
      data: {
        username: username,
        password: password
      }
    };
    await axios(options)
      .then(response => {
        const expirationDate = new Date(
          new Date().getTime() + 24 * 60 * 60 * 1000
        );
        localStorage.setItem("live555Token", response.data.accessToken);
        localStorage.setItem("expirationDate", expirationDate);
        dispatch(authSuccess(response.data.accessToken));
        dispatch(checkAuthTimeout(24 * 60 * 60));
        dispatch(setAuthRedirectPath("/matches"));
      })
      .catch(err => {
        dispatch(authFail(`no token - ${err}`));
        dispatch(setAuthRedirectPath("/login"));
      });
  };
};

export const setAuthRedirectPath = path => {
  return {
    type: actionTypes.SET_AUTH_REDIRECT_PATH,
    path: path
  };
};

export const authCheckState = () => {
  return async dispatch => {
    const token = localStorage.getItem("live555Token");
    if (!token) {
      await dispatch(logout());
      await dispatch(setAuthRedirectPath("/login"));
    } else {
      const expirationDate = new Date(localStorage.getItem("expirationDate"));
      if (expirationDate <= new Date()) {
        await dispatch(logout());
        await dispatch(setAuthRedirectPath("/login"));
      } else {
        await dispatch(authSuccess(token));
        await dispatch(
          checkAuthTimeout(
            (expirationDate.getTime() - new Date().getTime()) / 1000
          )
        );
        await dispatch(setAuthRedirectPath("/matches"));
      }
    }
  };
};